import CountUp from "react-countup";
import {MonitorCheck, MonitorDot, Unplug} from 'lucide-react';
import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useState} from "react";
import {Skeleton} from "antd";
import {APIv1} from "../../../../api";
import DeviceHealthDonut from "./DeviceHealthDonut";
import '../BaseNumberCardStyle.css'

const DeviceStatusCard = () => {
    const {t} = useTranslation();
    const [userData, setUserData] = useState({});
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [hoveredKey, setHoveredKey] = useState(null);  // segment hovered in the donut

    const fetchDeviceData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await APIv1.get('/device/status/activity', {
                headers: {
                    Authorization: `Token ${userData.token}`,
                },
            });
            const responseData = response.data;

            setData({
                totalCount: responseData.total,
                activeCount: responseData.active,
                inactiveCount: responseData.inactive,
                disconnectedCount: responseData.disconnected,
            });

        } catch (error) {
            console.error('Error fetching user data:', error);
        } finally {
            setLoading(false);
        }
    }, [userData.token]);

    useEffect(() => {
        if (!userData.token) return;

        fetchDeviceData()
    }, [userData.token])


    useEffect(() => {
        const items = JSON.parse(localStorage.getItem('user'));
        if (items) {
            setUserData(items);
        }
    }, [userData.token]);

    const segments = [
        {
            key: 'active',
            label: t("common.active"),
            Icon: MonitorCheck,
            color: "#28a745",
            tone: 'active',
            value: data.activeCount,
        },
        {
            key: 'suspended',
            label: t("common.suspended"),
            Icon: MonitorDot,
            color: "#6c757d",
            tone: 'inactive',
            value: data.inactiveCount,
        },
        {
            key: 'disconnected',
            label: t("common.disconnected"),
            Icon: Unplug,
            color: "#dc3545",
            tone: 'inactive',
            value: data.disconnectedCount,
        },
    ];

    return (
        <div className="analysis__metrics__card-device__status analysis__metrics__card">
            <h2>{t("analysis.numbersStats.mainTitles.devicesStatusTitle")}</h2>
            <div className="analysis__metrics__health">
                {loading ? (
                    <Skeleton.Avatar active shape="circle" size={120}/>
                ) : (
                    <DeviceHealthDonut
                        total={data.totalCount || 0}
                        active={data.activeCount || 0}
                        segments={segments}
                        onHoverChange={setHoveredKey}
                        highlightKey={hoveredKey}
                    />
                )}
                <div className={`analysis__metrics__container${hoveredKey ? " analysis__metrics__container--focused" : ""}`}>
                    {segments.map(({key, label, Icon, color, tone, value}) => {
                        const percent = data.totalCount > 0 ? Math.round(((value || 0) / data.totalCount) * 100) : 0;

                        return (
                            <div
                                className={`analysis__metrics__card analysis__metrics__health-tile${hoveredKey === key ? " analysis__metrics__health-tile--highlighted" : ""}`}
                                key={key}
                                style={{'--tile-color': color}}
                                onMouseEnter={() => setHoveredKey(key)}
                                onMouseLeave={() => setHoveredKey(null)}
                            >
                                <div className="analysis__metrics__health-tile-head">
                                    <span className="analysis__metrics__label">{label}</span>
                                    {!loading && <span className="analysis__metrics__health-percent">{percent}%</span>}
                                </div>
                                <div className={`analysis__metrics__value analysis__metrics__value--${tone}`}>
                                    <Icon className="analysis__metrics__icon" color={color}/>
                                    {loading ? (
                                        <Skeleton.Button active style={{width: 60, height: 20}}/>
                                    ) : (
                                        <CountUp end={value || 0} duration={3}/>
                                    )}
                                </div>
                                <div className="analysis__metrics__share">
                                    <span
                                        className="analysis__metrics__share-fill"
                                        style={{width: loading ? 0 : `${percent}%`, background: color}}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}

export default DeviceStatusCard;
